module.exports = __webpack_public_path__ + "img/use-app.0bafd8d2.png";